export const LOGGER = "error";

export const RELAY_URL = "wss://relay.walletconnect.com";

export const PROTOCOL = "wc";
export const WC_VERSION = 2;
export const CONTEXT = "universal_provider";

export const STORAGE = `${PROTOCOL}@${WC_VERSION}:${CONTEXT}:`;

export const RPC_URL = "https://rpc.walletconnect.com/v1/";

export const GENERIC_SUBPROVIDER_NAME = "generic";

export const BUNDLER_URL = `${RPC_URL}bundler`;
